// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemTemplatesPage_container__2pl0G","title":"ItemTemplatesPage_title__1rIgZ"};